function y(n) {
  const e = n?.trim();
  return e ? /^(New session - |Child session - )\d{4}-\d{2}-\d{2}T/.test(e) : !0;
}
function l(n, e) {
  if (!n || typeof n != "object") {
    const p = e?.trim();
    return p ? {
      id: p
    } : null;
  }
  const t = n, i = t.info && typeof t.info == "object" && !Array.isArray(t.info) ? t.info : t.session && typeof t.session == "object" && !Array.isArray(t.session) ? t.session : t, d = String(i.id ?? t.id ?? e ?? "").trim();
  if (!d) return null;
  const s = i.title ?? i.name ?? t.title ?? t.name, a = typeof s == "string" && s.trim() ? s.trim() : void 0, o = i.parentID ?? i.parentId ?? i.parent_id ?? t.parentId ?? t.parentID, c = typeof o == "string" && o.trim() ? o.trim() : void 0, f = r(i.user ?? t.user), u = r(i.tenant ?? t.tenant), m = typeof i.isHidden == "boolean" ? i.isHidden : typeof t.isHidden == "boolean" ? t.isHidden : void 0;
  return {
    ...t,
    ...i,
    id: d,
    ...a ? {
      title: a
    } : {},
    ...c ? {
      parentId: c
    } : {},
    ...f ? {
      user: f
    } : {},
    ...u ? {
      tenant: u
    } : {},
    ...m !== void 0 ? {
      isHidden: m
    } : {}
  };
}
function A(n) {
  const e = r(n.user);
  return e ? {
    ...n,
    user: e
  } : n;
}
function r(n) {
  if (!n || typeof n != "object" || Array.isArray(n)) return;
  const e = n, t = String(e.id ?? "").trim();
  if (!t) return;
  const i = typeof e.name == "string" && e.name.trim() ? e.name.trim() : void 0;
  return i ? {
    id: t,
    name: i
  } : {
    id: t
  };
}
export {
  y as isDefaultAssistantSessionTitle,
  A as normalizeAiAssistantMessage,
  l as normalizeAiAssistantSession
};
